{
  "fr": {
    "survey_type": {
      "actions": {
        "changeResponsible": "Changez responsable"
      },
      "attributes": {
        "introduction": "Introduction",
        "responsible": "Responsable",
        "title": "Titre"
      },
      "labels": {
        "ask_question": "Quel genre de question voulez-vous poser?",
        "editInternalTitle": "Modifier le titre interne?",
        "explainerNPSPart1": "Le Score Net du Promoteur est un indice compris entre -100 et 100 qui mesure la volonté des clients de recommander votre organisation ou vos projets à d'autres.",
        "explainerOpinionScale": "Mesurez l'accord de vos clients avec un énoncé général.",
        "fixed_choice": "Question à choix multiple",
        "hidePreview": "Masquer l'exemple",
        "moreInfo": "Plus d'informations",
        "nps": "Score Net du Promoteur",
        "npsQuestion": "NPS",
        "open_ended": "Question ouverte",
        "opinion_scale": "Échelle d'opinion",
        "preview": "Example",
        "satisfaction": "Satisfaction",
        "selectSurveyType": "Sélectionner la formulaire",
        "showPreview": "Afficher l'exemple",
        "tab_summary": "Sommaire",
        "tab_units": "Unités",
        "yes_no": "Oui-Non"
      },
      "navigation": {
        "backToSurveyTypes": "Retour aux formulaires"
      },
      "snackbars": {
        "duplicate": "Un formulaire a été créé, mais le processus de copie à partir du modèle peut prendre quelques minutes."
      },
      "toasts": {
        "bulk_delete": "Formulaire supprimée avec succès | Formulaires supprimées avec succès",
        "update": "Formulaire mis à jour avec succès"
      },
      "validation": {
        "nameAlreadyTaken": "Le nom est déjà pris pour ce projet",
        "need_name": "Titre requis",
        "selectSurveyType": "Sélectionnez au moins 1 formulaire"
      }
    }
  }
}
